/**
 * The "jump to page" affordance used by all three result sections. Every finding links to
 * the exact page in the relevant document (report or letter of instruction).
 */
export function PageLink({
  page,
  doc,
  onJump,
}: {
  page: number | null;
  doc: 'report' | 'loi';
  onJump: (doc: 'report' | 'loi', page: number) => void;
}) {
  if (page == null) return <span className="muted page-link page-link--none">No page reference</span>;
  return (
    <button type="button" className="page-link" onClick={() => onJump(doc, page)}>
      {doc === 'loi' ? 'LOI' : 'Report'} · page {page}
    </button>
  );
}
